import i18n from './i18n';
import { FoodPreference } from 'fitbeat.models';

export const foodPreferences = [
  {
    display: i18n.t('nutrition:AllFoodGroups'),
    value: FoodPreference.AllFoodGroups,
  },
  {
    display: i18n.t('nutrition:Vegetarian'),
    value: FoodPreference.Vegetarian,
  },
  {
    display: i18n.t('nutrition:Vegan'),
    value: FoodPreference.Vegan,
  },
];
